<div class="modal-main-wrapper" >
    <div class="close-container">
        <div class="img-container" >
            <img src="../../../assets/icons/Close.svg" (click)="cancel()">
        </div>        
    </div>
    <div class="content-wrapper" >
        <img [src]="confirmationData.icon" alt="confirm"  class="icon"/>
        <div class="message">{{confirmationData.message}}</div>
    </div>
    <footer>
    <div class="button-wrapper" >
        <button class="action-btn white-text" (click)="confirm()">Yes</button>
        <button  class="action-btn white-text" (click)="reject()">No</button>
        <button  *ngIf="!confirmationData.button?.hideCancel" class="action-btn white-text" (click)="cancel()">Cancel</button>
    </div>
</footer>
</div>